import React, { useState } from 'react';
import { ThemeProvider } from 'styled-components';

import GlobalStyle from './styles/global';
import { themes } from './styles/theme';

import { AppContext, ErrorContext } from './context';
import Header from './components/Header';
import Footer from './components/Footer';
import Routes from './routes/Routes';
import Loading from './components/Loading';
import ErrorModal from './components/ErrorModal';
import { useDeviceType } from './hooks';
import EmbeddedChat from './components/EmbeddedChat';
import ModalLgpd from './components/ModalLgpd';

const capTheme = () => ({
  ...themes.default,
  ...themes.capTheme,
});
const ibcTheme = {
  ...themes.default,
  ...themes.capTheme,
  ...themes.ibcTheme,
};
const getInitialContext = () => {
  const storedCtx = sessionStorage.getItem('context');
  if (storedCtx) {
    return JSON.parse(storedCtx);
  }
  return {
    urlChat: '',
    showEmbeddedChat: false,
    showFooterChat: true,
    showLgpd: false,
  };
};

function App() {
  const theme = capTheme();
  const { mobile } = useDeviceType();
  const [errorContext, setErrorContext] = useState({
    show: false,
    setContext: newCtx => {
      setErrorContext({
        message:
          'Nossos serviços estão temporariamente indisponíveis. Tente novamente mais tarde. ',
        title: 'Ops! Algo deu errado.',
        ...newCtx,
        setContext: errorContext.setContext,
      });
    },
  });
  const [context, setContext] = useState({
    ...getInitialContext(),
    isMobile: mobile,

    setContext: newCtx => {
      const fullCtx = {
        ...getInitialContext(),
        isMobile: mobile,
        ...newCtx,
        setContext: context.setContext,
        clearContext: context.clearContext,
      };
      sessionStorage.setItem('context', JSON.stringify(fullCtx));
      setContext(fullCtx);
    },
    clearContext: () => {
      const clearedContext = {
        setContext: context.setContext,
        clearContext: context.clearContext,
      };
      sessionStorage.setItem('context', JSON.stringify(clearedContext));
      setContext(clearedContext);
    },
  });

  const handleConfirm = () => {
    context.setContext({ showLgpd: false });
    sessionStorage.setItem('lgpd', true);
  };

  return (
    <ThemeProvider theme={context.ibcLogged ? ibcTheme : theme}>
      <ErrorContext.Provider
        value={{
          ...errorContext,
        }}
      >
        <AppContext.Provider
          value={{
            ...context,
          }}
        >
          <>
            <GlobalStyle goals={window.location.href.includes('objetivo')} />
            <Header icon={theme.icon} />
            <div className="App">
              <Routes />
            </div>
            <Footer showFooterChat={context.showFooterChat} />
            <EmbeddedChat isMobile={mobile} />
            {context.loading && <Loading />}
            {errorContext.show && (
              <ErrorModal
                showFooter
                onReject={() => {
                  errorContext.setContext({
                    show: false,
                  });
                  if (errorContext.onReject) {
                    errorContext.onReject();
                  }
                }}
                text={errorContext.message}
                title={errorContext.title}
              />
            )}
          </>
        </AppContext.Provider>
        <ModalLgpd open={context.showLgpd} onClick={handleConfirm} />
      </ErrorContext.Provider>
    </ThemeProvider>
  );
}

export default App;
